import VueRouter from 'vue-router'
import { RouteName } from './enum'
import { routes } from './routes'

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from) {
    const skipScrolling = to.params.scrollToAddressSearch
    const sameRoute = to.name === from.name
    const fromSupportPageDefault = from.name === RouteName.SupportPageDefault
    const toSupportPage = to.name === RouteName.SupportPage

    if (!skipScrolling && !sameRoute && !fromSupportPageDefault || !skipScrolling && fromSupportPageDefault && !toSupportPage) {
      return {
        x: 0,
        y: 0
      }
    }
    return null
  }
})

export default router
